import { render } from "./trend_new.vue?vue&type=template&id=1fb7952b&scoped=true"
import script from "./trend_new.vue?vue&type=script&lang=js"
export * from "./trend_new.vue?vue&type=script&lang=js"

import "./trend_new.vue?vue&type=style&index=0&id=1fb7952b&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb7952b"]])

export default __exports__